import { DiagnosisPage } from "./diagnosis";

export const Diagnosis = DiagnosisPage;
